import React from 'react';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

import Subscribe from './subscribe';
import { slideUp } from '../../utils/slideUp';

import black_logo_footer from "../../assets/images/black-logo-footer.png";


const Footer = () => {

  const footerLink = [
    {
      id: 1,
      name: "快速導覽",
      links: [
        {
          id: 1,
          link: "/about",
          label: "關於 DraftLegal"
        },
        {
          id: 2,
          link: "/services",
          label: "服務項目"
        },
        {
          id: 3,
          link: "/contract",
          label: "所有合約類型"
        },
        {
          id: 4,
          link: "/blog",
          label: "法律新知"
        },

      ]
    },
    {
      id: 2,
      name: "更多資訊",
      links: [
        {
          id: 1,
          link: "/faq",
          label: "常見問答"
        },
        {
          id: 2,
          link: "/privacy-policy",
          label: "隱私政策"
        },
        {
          id: 3,
          link: "/terms-conditions",
          label: "使用條款"
        },
        {
          id: 4,
          link: "/contact",
          label: "聯絡我們"
        },

      ]
    },
  ]
  return (

    <footer>
      {/*<Subscribe />*/}
      {/* -------- footer info */}
      <div className="footer-area">
        <div className="container" style={{ padding:'0px 30px' }}>
          <motion.div className="footer-info-area"
            initial="offscreen"
            whileInView="onscreen"
            variants={slideUp(1)}
            viewport={{ once: true, amount: 0.2 }}
          >
            <div className="row">

              {/* Left Side */}
              <div className="col-lg-4">
                <div className="single-footer-info ms-0">
                  <Link className="text-decoration-none logo" to="/"
                    style={{ width: '230px' }}
                  >
                    <img src={black_logo_footer} alt="black_logo_footer" />
                  </Link>

                  <p style={{ margin:'10px 0px 5px 0px', color: 'white' }}>DraftLegal 由國內大型律師事務所「經兆國際法律事務所」與賦語科技共同打造。</p>
                  <p style={{ margin:'5px 0px 10px 0px', color: 'white' }}>我們的願景是將法律服務中重複且低技術性的工作交由 AI 協作，使法律工作更加高效靈活。</p>
                  {/*
                    <p style={{ margin:'10px 0px' }}>同時，法律資源可透過科技更加普及，滿足社會的各種法律需求。</p>
                  */}

                </div>
              </div>

              {/* Right Side */}
              <div className="col-lg-8">
                <div className="row justify-content-center">

                  {/* Contact Us */}
                  <div className="col-lg-4 col-sm-12 col-md-4">
                    <div className="single-footer-info">
                      <h3>聯絡我們</h3>
                      <ul className="list-unstyled ps-0 mb-0">

                        <li>
                          <div style={{ fontSize:'1.2rem' }}>
                            <i className="fa fa-location-arrow"></i>
                          </div>
                          <div style={{ fontSize:'12.5px' }}>
                            台北市信義區忠孝東路四段563號9樓
                          </div>
                        </li>

                        <li>
                          <div style={{ fontSize:'1.2rem' }}>
                            <i className="fa fa-envelope"></i>
                          </div>
                          <div style={{ fontSize:'12.5px' }}>
                            <a className="text-decoration-none">經兆：service@law-meridian.com</a>
                          </div>
                          <div style={{ fontSize:'12.5px' }}>
                            <a className="text-decoration-none">賦語：admin@bytelingo.co</a>
                          </div>
                        </li>

                        <li>
                          <div style={{ fontSize:'1.2rem' }}>
                            <i className="fa fa-phone"></i>
                          </div>
                          <div style={{ fontSize:'12.5px' }}>
                            <a className="text-decoration-none" href="tel:55472543526">+886-2-2756-9918</a>
                          </div>
                        </li>

                      </ul>
                    </div>
                  </div>

                  {/* Quick Links and Resources */}
                  {
                    footerLink.map(({ id, links, name }) => {
                      return (
                        <div key={id} className="col-lg-4 col-6 col-sm-6 col-md-4">
                          <div className="single-footer-info">
                            <h3>{name}</h3>
                            <ul className="list-unstyled ps-0 mb-0">
                              {
                                links.map(({ id, label, link }) => {
                                  return (
                                    <li key={id}>
                                      <Link className="text-decoration-none" to={link}>{label}</Link>
                                    </li>
                                  )
                                })
                              }
                            </ul>
                          </div>
                        </div>
                      )
                    })
                  }

                </div>
              </div>



            </div>
          </motion.div>
        </div>
      </div>

      {/*---- CopyRight ----*/}
      <div className="copyright-area">
        <div className="container">
          <div className="copyright-content text-center" data-cue="slideInUp">
            <p style={{ marginBottom:'0px' }}>
              <span style={{ marginRight:'5px' }}>Copyright © 2025</span>
              <span><strong>  DraftLegal  </strong></span>
            </p>
            <p>經兆國際法律事務所 & 賦語科技 All Rights Reserved.</p>
          </div>
        </div>
      </div>

    </footer>
  )
}

export default Footer;


